module.exports = __webpack_public_path__ + "assets/img/36_790_big.16f19352.jpg";